





































import { Vue, Component, Emit, Prop } from 'vue-property-decorator';

@Component({})
export default class OpenOrCloseRegistrationModal extends Vue {
  @Prop({ default: false }) openForRegistration!: boolean;

  closeModal() {
    this.$emit('close');
  }

  @Emit('emitToParent')
  emitToParent() {
    this.closeModal();
    return;
  }
}
